import { useEffect, useState } from "react";
import { useUser } from "../../context/userContext";
import { getAgentDetailsByAgentId } from "../../api/userApi";

export default function UpdateUserDetailsForm({ userDetails, setUserDetails }) {
    const { user } = useUser();

    const handleUpdateUserProfile = () => {
        // Implement the logic to update user details
        // console.log("Updated User Details:", userDetails);
    }

    return (
        <div className="update-password-form-container">
            <form className="update-password-form" onSubmit={(e) => e.preventDefault()}>
                <div className="update-password-form-content">
                    <h3 className="update-password-form-title">Update User Details</h3>
                    <div className="form-group mt-3">
                        <label>Alias</label>
                        <input
                            type="text"
                            className="form-control mt-1"
                            placeholder="Alias"
                            value={userDetails?.alias || ''}
                            onChange={(e) => setUserDetails({ ...userDetails, alias: e.target.value })}
                        />
                    </div>
                    <div className="row mt-3">
                        <div className="col-md-6">
                            <div className="form-group">
                                <label>First Name</label>
                                <input
                                    type="text"
                                    className="form-control mt-1"
                                    placeholder="First Name"
                                    value={userDetails?.firstName || ''}
                                    onChange={(e) => setUserDetails({ ...userDetails, firstName: e.target.value })}
                                />
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="form-group">
                                <label>Last Name</label>
                                <input
                                    type="text"
                                    className="form-control mt-1"
                                    placeholder="Last Name"
                                    value={userDetails?.lastName || ''}
                                    onChange={(e) => setUserDetails({ ...userDetails, lastName: e.target.value })}
                                />
                            </div>
                        </div>
                    </div>

                    <div className="row mt-3">
                        <div className="col-md-6">
                            <div className="form-group">
                                <label>Email</label>
                                <input
                                    type="email"
                                    className="form-control mt-1"
                                    placeholder="Email"
                                    value={userDetails?.email || ''}
                                    onChange={(e) => setUserDetails({ ...userDetails, email: e.target.value })}
                                />
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="form-group">
                                <label>Phone Number</label>
                                <input
                                    type="tel"
                                    className="form-control mt-1"
                                    placeholder="Phone Number"
                                    value={userDetails?.phoneNumber || ''}
                                    onChange={(e) => setUserDetails({ ...userDetails, phoneNumber: e.target.value })}
                                />
                            </div>
                        </div>
                    </div>

                    <div className="form-group mt-3 d-grid gap-2 d-md-flex justify-content-md-end">
                        <button type="submit"
                            className="btn btn-primary"
                            onClick={handleUpdateUserProfile}
                            disabled
                        >
                            Update Details
                        </button>
                    </div>
                </div>
            </form>
        </div>
    );
}